import { render, staticRenderFns } from "./co-channel-list.vue?vue&type=template&id=5daef58b&"
import script from "./co-channel-list.vue?vue&type=script&lang=ts&"
export * from "./co-channel-list.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports